const Equipe = () => {

    return (

        <div>

            <h1>Equipe</h1>
            <h4>Advogados</h4>
                <p> ⚖️ Dra. Rayane Cristina</p>
                <p> ⚖️ Dra. Emilly</p>
                <p></p>
            <h4>Analista Jurídico</h4>
                <p> ⚖️ Denise</p>
                <p> ⚖️ Fernando</p>
            <h4>Recepcionista</h4>
                <p> ⚖️ Lorena Nascimento</p>
            <h4>Estagiários</h4>
                <p> ⚖️ Lorena</p>
                <p> ⚖️ Nayana</p>
                <p> ⚖️ Nonato</p>
                <p> ⚖️ Willian</p>
        </div>

    )

}

export default Equipe
